<template>
  <b-dropdown
    v-if="!$device.isMobile"
    variant="none"
    size="sm"
    no-caret
    class="dropdown w-100 rounded-lg cursor-pointer text-14 d-flex align-items-center position-relative"
  >
    <template #button-content>
      <div class="flex-fill text-left text-normal">
        {{ showLabel }}
      </div>
    </template>
    <template v-for="option in options">
      <b-dropdown-item :key="option.value" @click="select(option.value)">
        {{ option.label }}
      </b-dropdown-item>
    </template>
  </b-dropdown>

  <div
    v-else
    ref="dropdown"
    class="dropdown w-100 rounded-lg cursor-pointer text-14 d-flex align-items-center position-relative pl-3"
    :class="{disabled: disabled}"
    style="padding-right: 11px"
    @click.stop="toggle"
  >
    <div class="flex-fill">
      {{ showLabel }}
    </div>
    <i class="icon-Chevron-down text-16"></i>
    <action-sheet
      v-if="isOptionsShow"
      ref="action-sheet"
      :title="title"
      :sheet-height="optionsHeight"
      @close="isOptionsShow = false"
    >
      <div
        v-for="option in options"
        :key="option.value"
        class="position-relative option p-3 d-flex align-items-center"
        @click="select(option.value)"
      >
        {{ option.label }}
        <i
          v-if="value === option.value"
          class="icon-Check"
          :class="iconClass"
        ></i>
      </div>
    </action-sheet>
  </div>
</template>

<script>
import ActionSheet from '@/components/Base/ActionSheet.vue';
export default {
  components: {
    ActionSheet,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      default: null,
    },
    options: {
      type: Array,
      required: true,
    },
    iconClass: {
      type: String,
      default: 'text-positive',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOptionsShow: false,
    };
  },
  computed: {
    optionsHeight() {
      return 51 * (this.options.length + 1) + 'px';
    },
    showLabel() {
      const option = this.options.find((option) => option.value === this.value);
      return (option && option.label) || '';
    },
  },
  methods: {
    toggle() {
      this.isOptionsShow = !this.isOptionsShow;
    },
    select(value) {
      this.$emit('input', value);
      this.closeOptions();
    },
    closeOptions() {
      this.$device.isMobile
        ? this.$refs['action-sheet'].closeSheet()
        : (this.isOptionsShow = false);
    },
  },
};
</script>

<style lang="scss" scoped>
.dropdown {
  display: inline-block;
  height: 38px;
  border: 1px solid $line-1;

  .icon-Chevron-down {
    &:before {
      color: $primary;
    }
  }
  &.disabled {
    color: $font-grayscale-3;
    .icon-Chevron-down {
      &:before {
        color: $font-grayscale-3;
      }
    }
  }
}

:deep .dropdown-menu {
  width: 100%;
  max-height: 135px;
  overflow: auto;
}
</style>
